/**
import { isArray } from 'lodash';
 * 获得数组平均数；保存两位小数
 * @param numbers
 * @returns
 */
export function average(numbers: string[]): string {
    if (Array.isArray(numbers)) {
        const data = numbers.map((x: string) => {
            return Number(x);
        });
        return (data.reduce((a, b) => a + b) / numbers.length).toFixed(2);
    } else {
        return '';
    }
}

/**
 * 二维数组转置
 */
export function arrayTransposition(arr: string[][]): string[][] {
    const data = arr[0];
    if (Array.isArray(data)) {
        const newArray = data.map((_col, i) => {
            return arr.map((row) => {
                return row[i];
            });
        });
        return newArray;
    } else {
        return [];
    }
}

/**
 * 数组去重
 * 要求重复的值改为`值-1`的形式
 */
export function removeDuplicates(arr: string[]): string[] {
    let obj = {};
    let resultArr: string[] = [];

    for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        if (!obj[item]) {
            obj[item] = 1;
            resultArr.push(item);
        } else {
            let newItem = item + '-' + obj[item];
            obj[item]++;
            obj[newItem] = 1;
            resultArr.push(newItem);
        }
    }
    return resultArr;
}
